import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './footer.css';

class Footer extends Component {
  render() {
    return (
      <div className="Footer">
        <div className="FooterContainer">
          <Link className="Link" to="/privacy">
            Privacy Policy
          </Link>
          <Link className="Link" to="/terms">
            Terms Of Service
          </Link>
          <Link className="Link" to="/support">
            Support
          </Link>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js